export const billingInformationCompleted = () => ({
  type: 'Billing Information Completed',
});
